import { JobProcedureFormCopilotConfirmation } from "./procedure-copilot-confirmation-details.model";

export interface JobProcedureSummaryReview {
	jobProcedureId: number;
	procedureName: string;
	assetName: string;
	siteName: string;
	siteAddress: string;
	jobId: number;
	procedureSummaryDocumentId?: number;
	documentUrl?: string;
	jobProcedureSteps: JobProcedureFormDetails[];
}

export interface JobProcedureFormDetails{
	jobProcedureId: number;
	jobProcedureFormId: number;
	stepName: string;
	stepNumber: number;
	isConfirmed: boolean;
	isIssueLogged: boolean;
	qrAccountSiteResourceId?: number;
	pictureConfirmationRequired: boolean;
	accessCoolOffPeriodMinutes?: number;
	isDigitalSignatureRequired: boolean;
	allowSkipValidation: boolean;
	skipValidations: boolean;
	isBypassed: boolean;
	bypassReason: string;
	bypassedBy: string;
	bypassedOn?: Date;
	isCompleted: boolean;
	completedBy: string;
	completeOn?: Date;
	duration?: number;
	createdOn: Date;
	isEnabled: boolean;
	hasMissingFormData: boolean;
	hasMissingSignature: boolean;
	hasMissingPhotoConfirmation: boolean;
	enabledAt?: Date;
	firstOpenedOn?: Date;
	lastSubmittedOn?: Date;

	validationsSkippedBy: string;
	validationsSkippedOn?: Date;
	barcodeIconColor: ProcedureFormIconColor;
	photoIconColor: ProcedureFormIconColor;
	timeConstraintIconColor: ProcedureFormIconColor;
	signatureIconColor: ProcedureFormIconColor;
	showStrikethrough?: boolean;
	showBarcodeIcon: boolean;
}

export enum ProcedureFormIconColor {
	ProcedureFormDefaultIconColor = 0,
	ProcedureFormCompletedIconColor = 1,
	ProcedureFormRequiredIconColor = 2
}

export const ProcedureFormIconColorMap: Record<ProcedureFormIconColor, string> = {
	[ProcedureFormIconColor.ProcedureFormDefaultIconColor]: '#929292',
	[ProcedureFormIconColor.ProcedureFormCompletedIconColor]: '#0D6E1F',
	[ProcedureFormIconColor.ProcedureFormRequiredIconColor]: '#CE0C0C'
};

